import {IWindowService} from 'angular';
import AppActionHandler from './app.action-handler.service';
import ActionDispatcherService from './common/actions/core/action-dispatcher.service';
import ErrorMessageHandler from './common/services/error/error.message.handler';
import MixpanelService from './common/services/analytics/mixpanel.service';

export default function runBlock(
  ngMeta,
  i18n,
  $state,
  config,
  $window: IWindowService,
  actionDispatcher: ActionDispatcherService,
  appActionHandler: AppActionHandler,
  errorMessageHandler: ErrorMessageHandler,
  mixpanelService: MixpanelService
) {
  'ngInject';

  mixpanelService.init();

  if(config.httpsEnabled && $window.location.protocol == 'http:' && $window.location.hostname !== 'localhost') {
    $window.location.protocol = 'https:' ;
  }

  actionDispatcher.register(appActionHandler);
  actionDispatcher.register(errorMessageHandler);

  $state.defaultErrorHandler(() => {
    // Do not log transitionTo errors.
    // TODO: Redirect to an error page here when the one will be implemented.
  });

  ngMeta.init();

  const htmlElement = angular.element('html');
  htmlElement.attr('lang', i18n.getCurrentLanguage());

  angular
    .element('#build-revision')
    .text(`${buildRevision.branch} [${buildRevision.hash}]`);

  // Override random() with a custom implementation
  Math.random = function (): number {
    const randomArray = new Uint32Array(1);
    window.crypto.getRandomValues(randomArray);
    const randomValue = randomArray[0] / (0xffffffff + 1);
    return randomValue;
  };
}



// WEBPACK FOOTER //
// ./src/app/app.run.ts